/* eslint-disable max-lines */
import { TPageMapValue } from 'models/common.model'
import { lazy } from 'react'
import { PageIdStylioArch } from './pages'

type TIdToPageMap = Record<PageIdStylioArch, TPageMapValue>

export const ID_TO_PAGE_MAP_STYLIO_ARCH: TIdToPageMap = {
  [PageIdStylioArch.AGE_ARCH]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_arch/pages/questions/AgeQuestion').then(
        (m) => ({
          default: m.AgeQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_arch/pages/questions/AgeQuestion'),
  },
  [PageIdStylioArch.SHOP_SMARTER_ARCH]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_arch/pages/shop-smarter/ShopSmarter').then(
        (m) => ({
          default: m.ShopSmarter,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_arch/pages/shop-smarter/ShopSmarter'),
  },
  [PageIdStylioArch.HAIR_COLOR_ARCH]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_arch/pages/questions/HairColorQuestion'
      ).then((m) => ({
        default: m.HairColorQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_arch/pages/questions/HairColorQuestion'),
  },
  [PageIdStylioArch.WARDROBE_COLORS_ARCH]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_arch/pages/questions/WardrobeColorsQuestion'
      ).then((m) => ({
        default: m.WardrobeColorsQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_arch/pages/questions/WardrobeColorsQuestion'
      ),
  },
  [PageIdStylioArch.COLOR_CONFIDENCE_ARCH]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_arch/pages/questions/ColorConfidenceQuestion'
      ).then((m) => ({
        default: m.ColorConfidenceQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_arch/pages/questions/ColorConfidenceQuestion'
      ),
  },
  [PageIdStylioArch.EYES_COLOR_ARCH]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_arch/pages/questions/EyesColorQuestion'
      ).then((m) => ({
        default: m.EyesColorQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_arch/pages/questions/EyesColorQuestion'),
  },
  [PageIdStylioArch.SKIN_COLOR_ARCH]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_arch/pages/questions/SkinColorQuestion'
      ).then((m) => ({
        default: m.SkinColorQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_arch/pages/questions/SkinColorQuestion'),
  },
  [PageIdStylioArch.CLIMAT_ARCH]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_arch/pages/questions/ClimatQuestion').then(
        (m) => ({
          default: m.ClimatQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_arch/pages/questions/ClimatQuestion'),
  },
  [PageIdStylioArch.BODY_SHAPE_ARCH]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_arch/pages/questions/BodyShapeQuestion'
      ).then((m) => ({
        default: m.BodyShapeQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_arch/pages/questions/BodyShapeQuestion'),
  },
  [PageIdStylioArch.BODY_SHAPE_CONFIDENCE_ARCH]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_arch/pages/questions/BodyShapeConfidenceQuestion'
      ).then((m) => ({
        default: m.BodyShapeConfidenceQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_arch/pages/questions/BodyShapeConfidenceQuestion'
      ),
  },
  [PageIdStylioArch.SHOW_OFF_FEATURES_ARCH]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_arch/pages/questions/ShowOffFeaturesQuestion'
      ).then((m) => ({
        default: m.ShowOffFeaturesQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_arch/pages/questions/ShowOffFeaturesQuestion'
      ),
  },
  [PageIdStylioArch.STYLIO_TO_HELP_ARCH]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_arch/pages/questions/StylioToHelp').then(
        (m) => ({
          default: m.StylioToHelp,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_arch/pages/questions/StylioToHelp'),
  },
  [PageIdStylioArch.MAIN_GOAL_ARCH]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_arch/pages/questions/MainGoalQuestion').then(
        (m) => ({
          default: m.MainGoalQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_arch/pages/questions/MainGoalQuestion'),
  },
  [PageIdStylioArch.WHERE_TO_SHOP_ARCH]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_arch/pages/questions/WhereToShopQuestion'
      ).then((m) => ({
        default: m.WhereToShopQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_arch/pages/questions/WhereToShopQuestion'),
  },
  [PageIdStylioArch.WARDROBE_PERCENTAGE_ARCH]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_arch/pages/questions/WardrobePercentageQuestion'
      ).then((m) => ({
        default: m.WardrobePercentageQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_arch/pages/questions/WardrobePercentageQuestion'
      ),
  },
  [PageIdStylioArch.URGE_1_ARCH]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_arch/pages/urge/UrgePageVariant1').then(
        (m) => ({
          default: m.UrgePageVariant1,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_arch/pages/urge/UrgePageVariant1'),
  },
  [PageIdStylioArch.URGE_2_ARCH]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_arch/pages/urge/UrgePageVariant2').then(
        (m) => ({
          default: m.UrgePageVariant2,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_arch/pages/urge/UrgePageVariant2'),
  },
  [PageIdStylioArch.URGE_3_ARCH]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_arch/pages/urge/UrgePageVariant3').then(
        (m) => ({
          default: m.UrgePageVariant3,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_arch/pages/urge/UrgePageVariant3'),
  },
  [PageIdStylioArch.URGE_9_ARCH]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_arch/pages/urge/UrgePageVariant9').then(
        (m) => ({
          default: m.UrgePageVariant9,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_arch/pages/urge/UrgePageVariant9'),
  },
  [PageIdStylioArch.URGE_4_ARCH]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_arch/pages/urge/UrgePageVariant4').then(
        (m) => ({
          default: m.UrgePageVariant4,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_arch/pages/urge/UrgePageVariant4'),
  },
  [PageIdStylioArch.URGE_5_ARCH]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_arch/pages/urge/UrgePageVariant5').then(
        (m) => ({
          default: m.UrgePageVariant5,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_arch/pages/urge/UrgePageVariant5'),
  },
  [PageIdStylioArch.URGE_6_ARCH]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_arch/pages/urge/UrgePageVariant6').then(
        (m) => ({
          default: m.UrgePageVariant6,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_arch/pages/urge/UrgePageVariant6'),
  },
  [PageIdStylioArch.STYLE_PROFILE_ARCH]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_arch/pages/urge/StyleProfilePage').then(
        (m) => ({
          default: m.StyleProfilePage,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_arch/pages/urge/StyleProfilePage'),
  },
  [PageIdStylioArch.WARDROBE_READY_ARCH]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_arch/pages/questions/WardrobeReadyQuestion'
      ).then((m) => ({
        default: m.WardrobeReadyQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_arch/pages/questions/WardrobeReadyQuestion'),
  },
  [PageIdStylioArch.URGE_7_ARCH]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_arch/pages/urge/UrgePageVariant7').then(
        (m) => ({
          default: m.UrgePageVariant7,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_arch/pages/urge/UrgePageVariant7'),
  },
  [PageIdStylioArch.URGE_8_ARCH]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_arch/pages/urge/UrgePageVariant8').then(
        (m) => ({
          default: m.UrgePageVariant8,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_arch/pages/urge/UrgePageVariant8'),
  },
  [PageIdStylioArch.STYLE_DRAWN_TO_ARCH]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_arch/pages/questions/StyleDrawnToQuestion'
      ).then((m) => ({
        default: m.StyleDrawnToQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_arch/pages/questions/StyleDrawnToQuestion'),
  },
  [PageIdStylioArch.OUTFIT_EMOTION_ARCH]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_arch/pages/questions/OutfitEmotionQuestion'
      ).then((m) => ({
        default: m.OutfitEmotionQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_arch/pages/questions/OutfitEmotionQuestion'),
  },
  [PageIdStylioArch.STYLE_DISCOVERY_ARCH]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_arch/pages/questions/StyleDiscoveryQuestion'
      ).then((m) => ({
        default: m.StyleDiscoveryQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_arch/pages/questions/StyleDiscoveryQuestion'
      ),
  },
  [PageIdStylioArch.NOTHING_TO_WEAR_ARCH]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_arch/pages/questions/NothingToWearQuestion'
      ).then((m) => ({
        default: m.NothingToWearQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_arch/pages/questions/NothingToWearQuestion'),
  },
  [PageIdStylioArch.ARCHETYPE_INTRO_ARCH]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_arch/pages/archetype/ArchetypeIntro').then(
        (m) => ({
          default: m.ArchetypeIntro,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_arch/pages/archetype/ArchetypeIntro'),
  },
  [PageIdStylioArch.DRESSED_FEEL_ARCH]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_arch/pages/archetype/DressedFeelQuestion'
      ).then((m) => ({
        default: m.DressedFeelQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_arch/pages/archetype/DressedFeelQuestion'),
  },
  [PageIdStylioArch.STYLE_MATTERS_MOST_ARCH]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_arch/pages/archetype/StyleMattersMostQuestion'
      ).then((m) => ({
        default: m.StyleMattersMostQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_arch/pages/archetype/StyleMattersMostQuestion'
      ),
  },
  [PageIdStylioArch.OUTFIT_VIBE_ARCH]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_arch/pages/archetype/OutfitVibeQuestion'
      ).then((m) => ({
        default: m.OutfitVibeQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_arch/pages/archetype/OutfitVibeQuestion'),
  },
  [PageIdStylioArch.OUTFIT_COMPLIMENT_ARCH]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_arch/pages/archetype/OutfitComplimentQuestion'
      ).then((m) => ({
        default: m.OutfitComplimentQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_arch/pages/archetype/OutfitComplimentQuestion'
      ),
  },
  [PageIdStylioArch.SHOP_PULLS_FIRST_ARCH]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_arch/pages/archetype/ShopPullsFirstQuestion'
      ).then((m) => ({
        default: m.ShopPullsFirstQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_arch/pages/archetype/ShopPullsFirstQuestion'
      ),
  },
  [PageIdStylioArch.ARCHETYPE_LOADING_ARCH]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_arch/pages/archetype/ArchetypeLoading').then(
        (m) => ({
          default: m.ArchetypeLoading,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_arch/pages/archetype/ArchetypeLoading'),
  },
  [PageIdStylioArch.ARCHETYPE_RESULT_ARCH]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_arch/pages/archetype/ArchetypeResult').then(
        (m) => ({
          default: m.ArchetypeResult,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_arch/pages/archetype/ArchetypeResult'),
  },
  [PageIdStylioArch.LOOKING_FEMININE_ARCH]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_arch/pages/questions/LookingFeminineQuestion'
      ).then((m) => ({
        default: m.LookingFeminineQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_arch/pages/questions/LookingFeminineQuestion'
      ),
  },
  [PageIdStylioArch.STYLES_FEEL_LIKE_YOU_ARCH]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_arch/pages/questions/StylesFeelLikeYouQuestion'
      ).then((m) => ({
        default: m.StylesFeelLikeYouQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_arch/pages/questions/StylesFeelLikeYouQuestion'
      ),
  },
  [PageIdStylioArch.TALL_ARCH]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_arch/pages/questions/TallQuestion').then(
        (m) => ({
          default: m.TallQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_arch/pages/questions/TallQuestion'),
  },
  [PageIdStylioArch.WEIGHT_ARCH]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_arch/pages/questions/WeightQuestion').then(
        (m) => ({
          default: m.WeightQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_arch/pages/questions/WeightQuestion'),
  },
  [PageIdStylioArch.WARDROBE_CHANGED_ARCH]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_arch/pages/questions/WardrobeChangedQuestion'
      ).then((m) => ({
        default: m.WardrobeChangedQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_arch/pages/questions/WardrobeChangedQuestion'
      ),
  },
  [PageIdStylioArch.FAVORITE_COLORS_ARCH]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_arch/pages/questions/FavoriteColorsQuestion'
      ).then((m) => ({
        default: m.FavoriteColorsQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_arch/pages/questions/FavoriteColorsQuestion'
      ),
  },
  [PageIdStylioArch.LIKE_OR_DISLIKE_11_ARCH]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_arch/pages/likeOrDislike/LikeOrDislikeVariant11Arch'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant11Arch,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_arch/pages/likeOrDislike/LikeOrDislikeVariant11Arch'
      ),
  },
  [PageIdStylioArch.LIKE_OR_DISLIKE_14_ARCH]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_arch/pages/likeOrDislike/LikeOrDislikeVariant14Arch'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant14Arch,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_arch/pages/likeOrDislike/LikeOrDislikeVariant14Arch'
      ),
  },
  [PageIdStylioArch.LIKE_OR_DISLIKE_15_ARCH]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_arch/pages/likeOrDislike/LikeOrDislikeVariant15Arch'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant15Arch,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_arch/pages/likeOrDislike/LikeOrDislikeVariant15Arch'
      ),
  },
  [PageIdStylioArch.LIKE_OR_DISLIKE_18_ARCH]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_arch/pages/likeOrDislike/LikeOrDislikeVariant18Arch'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant18Arch,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_arch/pages/likeOrDislike/LikeOrDislikeVariant18Arch'
      ),
  },
  [PageIdStylioArch.LIKE_OR_DISLIKE_19_ARCH]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_arch/pages/likeOrDislike/LikeOrDislikeVariant19Arch'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant19Arch,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_arch/pages/likeOrDislike/LikeOrDislikeVariant19Arch'
      ),
  },
  [PageIdStylioArch.WALK_INTO_ROOM_ARCH]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_arch/pages/questions/WalkIntoRoomQuestion'
      ).then((m) => ({
        default: m.WalkIntoRoomQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_arch/pages/questions/WalkIntoRoomQuestion'),
  },
  [PageIdStylioArch.PERFECT_WEEKEND_ARCH]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_arch/pages/questions/PerfectWeekendQuestion'
      ).then((m) => ({
        default: m.PerfectWeekendQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_arch/pages/questions/PerfectWeekendQuestion'
      ),
  },
  [PageIdStylioArch.WARDROBE_FEEL_ARCH]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_arch/pages/questions/WardrobeFeelQuestion'
      ).then((m) => ({
        default: m.WardrobeFeelQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_arch/pages/questions/WardrobeFeelQuestion'),
  },
  [PageIdStylioArch.SHOPPING_ARCH]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_arch/pages/questions/ShoppingQuestion').then(
        (m) => ({
          default: m.ShoppingQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_arch/pages/questions/ShoppingQuestion'),
  },
  [PageIdStylioArch.SHOPPING_BUDGET_ARCH]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_arch/pages/questions/ShoppingBudgetQuestion'
      ).then((m) => ({
        default: m.ShoppingBudgetQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_arch/pages/questions/ShoppingBudgetQuestion'
      ),
  },
  [PageIdStylioArch.SHOPPING_PRIORITY_ARCH]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_arch/pages/questions/ShoppingPriorityQuestion'
      ).then((m) => ({
        default: m.ShoppingPriorityQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_arch/pages/questions/ShoppingPriorityQuestion'
      ),
  },
  [PageIdStylioArch.CURATED_LINKS_ARCH]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_arch/pages/questions/CuratedLinksQuestion'
      ).then((m) => ({
        default: m.CuratedLinksQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_arch/pages/questions/CuratedLinksQuestion'),
  },
  [PageIdStylioArch.LIFESTYLE_FOCUS_ARCH]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_arch/pages/questions/LifestyleFocusQuestion'
      ).then((m) => ({
        default: m.LifestyleFocusQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_arch/pages/questions/LifestyleFocusQuestion'
      ),
  },
  [PageIdStylioArch.OUTFIT_NEEDS_ARCH]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_arch/pages/questions/OutfitNeedsQuestion'
      ).then((m) => ({
        default: m.OutfitNeedsQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_arch/pages/questions/OutfitNeedsQuestion'),
  },
  [PageIdStylioArch.WARDROBE_ALIGNS_ARCH]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_arch/pages/questions/WardrobeAlignsQuestion'
      ).then((m) => ({
        default: m.WardrobeAlignsQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_arch/pages/questions/WardrobeAlignsQuestion'
      ),
  },
  [PageIdStylioArch.LIFESTYLE_CHANGES_ARCH]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_arch/pages/questions/LifestyleChangesQuestion'
      ).then((m) => ({
        default: m.LifestyleChangesQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_arch/pages/questions/LifestyleChangesQuestion'
      ),
  },
  [PageIdStylioArch.AMAZON_FRUSTRATION_ARCH]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_arch/pages/questions/AmazonFrustrationQuestion'
      ).then((m) => ({
        default: m.AmazonFrustrationQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_arch/pages/questions/AmazonFrustrationQuestion'
      ),
  },
  [PageIdStylioArch.PREPARE_FLOW_ARCH]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_arch/pages/prepareFlow/PrepareFlow').then(
        (m) => ({
          default: m.PrepareFlow,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_arch/pages/prepareFlow/PrepareFlow'),
  },
  [PageIdStylioArch.EMAIL_ARCH]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_arch/pages/email/Email').then((m) => ({
        default: m.Email,
      })),
    ),
    preload: () => import('nove8/cohorts/stylio_arch/pages/email/Email'),
  },
  [PageIdStylioArch.EMAIL_CONSENT_ARCH]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_arch/pages/email/EmailConsent').then(
        (m) => ({
          default: m.EmailConsent,
        }),
      ),
    ),
    preload: () => import('nove8/cohorts/stylio_arch/pages/email/EmailConsent'),
  },
  [PageIdStylioArch.NAME_ARCH]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_arch/pages/name/Name').then((m) => ({
        default: m.Name,
      })),
    ),
    preload: () => import('nove8/cohorts/stylio_arch/pages/name/Name'),
  },
  [PageIdStylioArch.READINESS_LEVEL_ARCH]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_arch/pages/readinessLevel/ReadinessLevel'
      ).then((m) => ({
        default: m.ReadinessLevel,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_arch/pages/readinessLevel/ReadinessLevel'),
  },
  [PageIdStylioArch.PRE_PAYWALL_OFFER_ARCH]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_arch/pages/prePaywallOffer/PrePaywallOffer'
      ).then((m) => ({
        default: m.PrePaywallOffer,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_arch/pages/prePaywallOffer/PrePaywallOffer'),
  },
  [PageIdStylioArch.SUBSCRIPTIONS_ARCH]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_arch/pages/subscriptions/SubscriptionsVariant1'
      ).then((m) => ({
        default: m.SubscriptionsVariant1,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_arch/pages/subscriptions/SubscriptionsVariant1'
      ),
  },
  [PageIdStylioArch.CANCEL_OFFER_ARCH]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_arch/pages/cancel-offer/CancelOffer').then(
        (m) => ({
          default: m.CancelOffer,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_arch/pages/cancel-offer/CancelOffer'),
  },
  [PageIdStylioArch.SUB_UPSELL_ARCH]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_arch/pages/sub-upsell/SubUpsell').then(
        (m) => ({
          default: m.SubUpsell,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_arch/pages/sub-upsell/SubUpsell'),
  },
  [PageIdStylioArch.UPSELL_ARCH]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_arch/pages/upsell/Upsell').then((m) => ({
        default: m.Upsell,
      })),
    ),
    preload: () => import('nove8/cohorts/stylio_arch/pages/upsell/Upsell'),
  },
  [PageIdStylioArch.ACCOUNT_NOVE8]: {
    Component: lazy(() =>
      import('nove8/modules/account/AccountNove8').then((m) => ({
        default: m.AccountNove8,
      })),
    ),
    preload: () => import('nove8/modules/account/AccountNove8'),
  },
  [PageIdStylioArch.DOWNLOAD_ARCH]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_arch/pages/download-app/DownloadDefault'
      ).then((m) => ({
        default: m.DownloadDefault,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_arch/pages/download-app/DownloadDefault'),
  },
}
